import styled from "styled-components";

export const MoodMeterHomeContent = styled.div`
  position: relative;
  border: 1px solid ${({ theme }) => theme.secondaryGrayLightNine};
  padding: 17px 38px;
  border-radius: 8px;
  width: 100vw;
  max-width: 80%;
  overflow: auto;
  min-height: 182px;
  max-height: 212px;
  .smiley-faces-container {
    display: flex;
    overflow-x: auto;
  }
  .smiley-faces-container button {
    margin: 0 14px;
    margin-bottom: 24px;
  }
  .makeStyles-root-11 {
    left: 0;
  }
  h6 {
    font-size: 18px;
  }
  .FeelingOptionsHeader svg {
    top: 17px !important;
    color: ${({ theme }) => theme.button.primary};
    font-size: 26px;
  }
  .left-container svg {
    width: 56px;
    height: 56px;
  }
  .MuiButtonBase-root {
    padding-top: 0 !important;
  }
  .MuiFormControlLabel-root {
    margin-bottom: 4px;
  }
  .felling-faces_btnnext {
    left: 0;
  }
  .felling-faces_btnnext button {
    width: 8%;
  }
  .MuiSvgIcon-root {
    margin: 5px;
    margin-top: 6px;
  }
  .FeelingOptionsHeader {
    margin-bottom: 16px;
  }
  .contact-check svg {
    margin-top: 2px;
  }
  .steps-2 .MuiFormGroup-root {
    padding-bottom: 7px !important;
  }
  .save-mood {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 3em;
    gap: 30px;
    .save-mood_info {
      text-align: start;
      margin-left: 18px;
    }
  }
  .mood-meter_disabled {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 25px;
  }
`;

export const SaveMoodSvg = styled.div`
  svg {
    width: auto;
    height: auto;
  }
`;
